module.exports = __webpack_public_path__ + "699ea01fcf4015cd3e409ec3b63238e2.jpg";